import request from '@/config/axios'

// 线路
export const getTourRoutePage = (params: any) => {
  return request.get({ url: '/scenic/route/page', params })
}

export const getTourRoute = (id: number) => {
  return request.get({ url: '/scenic/route/get', params: { id } })
}

export const createTourRoute = (data: any) => {
  return request.post({ url: '/scenic/route/create', data })
}

export const updateTourRoute = (data: any) => {
  return request.put({ url: '/scenic/route/update', data })
}

export const deleteTourRoute = (id: number) => {
  return request.delete({ url: '/scenic/route/delete', params: { id } })
}

export const deleteTourRouteList = (ids: number[]) => {
  return request.delete({ url: '/scenic/route/delete-list', params: { ids: ids.join(',') } })
}

export const submitTourRouteReview = (id: number) => {
  return request.post({ url: '/scenic/route/submit-review', params: { id } })
}

export const approveTourRoute = (id: number, auditRemark?: string) => {
  return request.post({ url: '/scenic/route/approve', params: { id, auditRemark } })
}

export const rejectTourRoute = (id: number, auditRemark: string) => {
  return request.post({ url: '/scenic/route/reject', params: { id, auditRemark } })
}

export const publishTourRoute = (id: number) => {
  return request.post({ url: '/scenic/route/publish', params: { id } })
}

export const offlineTourRoute = (id: number) => {
  return request.post({ url: '/scenic/route/offline', params: { id } })
}

export const exportTourRouteExcel = (params: any) => {
  return request.download({ url: '/scenic/route/export-excel', params })
}
